/**
 * @hidden
 */
export var isAuthor = function (user, msg) {
    return user && msg.author && user.id === msg.author.id;
};
//# sourceMappingURL=utils.js.map